import { createTransport } from './createTransport.js';
/**
 * @description Creates a custom transport given an EIP-1193 compliant `request` attribute.
 */
export function custom(provider) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    key = 'custom',
    name = 'Custom Provider',
    retryDelay
  } = config;
  return _ref => {
    var _config$retryCount;
    let {
      retryCount: defaultRetryCount
    } = _ref;
    return createTransport({
      key,
      name,
      request: provider.request.bind(provider),
      retryCount: (_config$retryCount = config.retryCount) !== null && _config$retryCount !== void 0 ? _config$retryCount : defaultRetryCount,
      retryDelay,
      type: 'custom'
    });
  };
}
//# sourceMappingURL=custom.js.map